import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

import styles from './DynamicAppointmentInformation.scss';

export const DynamicAppointmentInformation = ({ bookingText, children = null }) => (
  <div className={styles.CustomTextContainer}>
    <div
      className={styles.CustomTextContent}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(bookingText, { ADD_ATTR: ['target'] }),
      }}
    />
    {children}
  </div>
);

DynamicAppointmentInformation.propTypes = {
  bookingText: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};
